import React from 'react';
import { FiPhone, FiMail, FiGlobe, FiUser, FiMapPin } from 'react-icons/fi';

const InfoRow = ({ icon: Icon, label, value, isLink, href }) => {
  const content = isLink ? (
    <a href={href} target={href.startsWith('http') ? "_blank" : undefined} 
       rel="noopener noreferrer" 
       className="text-blue-600 hover:text-blue-800">
      {value}
    </a>
  ) : (
    <span>{value}</span>
  );

  return value ? (
    <div className="flex items-center gap-2 text-gray-600">
      <Icon className="w-4 h-4 text-gray-400 flex-shrink-0" />
      <span className="font-medium w-20">{label}:</span>
      {content}
    </div>
  ) : null;
};

const SectionCard = ({ title, children }) => (
    <div className="bg-white shadow-md rounded-lg p-6 mb-6">
      <h3 className="text-xl font-semibold mb-4 pb-2 border-b border-gray-200">
        {title}
      </h3>
      {children}
    </div>
  );

const ProviderCard = ({ providerInfo }) => {
  const { logo, name, contactPerson, address, callPhone, email, webSite } = providerInfo;

  return (
    <SectionCard title="Provider">
      <div className="flex flex-col sm:flex-row items-start gap-6">
        <div className="w-24 h-24 flex-shrink-0 bg-gray-50 rounded-lg overflow-hidden">
          {logo ? (
            <img 
              src={process.env.REACT_APP_KRUOZ_IMAGE_BASE_URL + logo} 
              alt={`${name} logo`} 
              className="w-full h-full object-contain"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-blue-50 to-gray-50">
              <span className="text-3xl font-bold text-gray-400">
                {name?.charAt(0)}
              </span>
            </div>
          )}
        </div>

        <div className="flex-grow grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-4">
          <div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">{name}</h2>
            <div className="space-y-2">
              <InfoRow 
                icon={FiUser}
                label="Contact"
                value={contactPerson}
              />
              <InfoRow 
                icon={FiMapPin}
                label="Address"
                value={address}
              />
            </div>
          </div>
          
          <div className="space-y-2">
            <InfoRow 
              icon={FiPhone}
              label="Phone"
              value={callPhone}
              isLink={true}
              href={`tel:${callPhone}`}
            />
            <InfoRow 
              icon={FiMail}
              label="Email"
              value={email}
              isLink={true}
              href={`mailto:${email}`}
            />
            <InfoRow 
              icon={FiGlobe}
              label="Website"
              value={webSite}
              isLink={true}
              href={webSite}
            />
          </div>
        </div>
      </div>
    </SectionCard>
  );
};

export default ProviderCard;